export const CATEGORIES_RECEIVED = "categories_received";
export const NEW_PRODUCTS_RECEIVED = "new_products_received";
export const KITS_RECEIVED = "kits_received";
export const DEVICES_RECEIVED = "devices_received";
export const VTRACK_ITEMS_RECEIVED = "vtrack_items_received";
export const LINEHAUL_ITEMS_RECEIVED = "linehaul_items_received";
export const ACCESSORIES_RECEIVED = "accessories_received";
export const ZEBRA_ACCESSORIES_RECEIVED = "zebra_accessories_received";
export const ZEBRA_TC26_ACCESSORIES_RECEIVED = "zebra_tc26_accessories_received";
export const ZEBRA_TC58_ACCESSORIES_RECEIVED = "zebra_tc58_accessories_received";
export const ZEBRA_TC78_ACCESSORIES_RECEIVED = "zebra_tc78_accessories_received";
export const PANASONIC_ACCESSORIES_RECEIVED = "panasonic_accessories_received";
export const PANASONIC_T1_ACCESSORIES_RECEIVED = "panasonic_t1_accessories_received";
export const SAMSUNG_ACCESSORIES_RECEIVED = "samsung_accessories_received";
export const UNIVERSAL_ACCESSORIES_RECEIVED = "universal_accessories_received";
export const PLANS_RECEIVED = "plans_received";
export const SERVICES_RECEIVED = "services_received";
export const CATEGORY_PRODUCTS_RECEIVED = "category_products_received";
export const KIT_QUANTIY_UPDATED = "kit_quantity_updated";
export const DEVICE_QUANTIY_UPDATED = "device_quantity_updated";
export const PRODUCT_SELECTED = "product_selected";
export const RENTALS_RECEIVED = "rentals_received";